<template>
  <concepts-list
    :selectedConcept.sync="currentConcept"
    :loading="loading"
    :loadingSupplies="loadingSupplies"
    :concepts="roadConcepts"
    :detail="currentDetail"
    :details="details"
    :catalog-id="currentCatalog && currentCatalog.id"
    @filterData="filterData"
    @showSupplies="loadConceptSupplies"
    @saved="conceptSaved"
    @updated="conceptUpdated"
    @deleteConcept="deleteConcept"
  >
    <catalog-menu
      slot="title"
      v-model="currentCatalogId"
      @catalogDataLoaded="loadCatalogData"
      button-class="md-danger"
    >
      <template slot="button" slot-scope="{ catalog }">
        <h6 class="text-left">
          Conceptos
          <br />
          {{ catalog.name }}
        </h6>
      </template>
    </catalog-menu>
  </concepts-list>
</template>

<script>
import ConceptsList from "./ConceptsList";
import catalogService from "@/services/catalog";
import CatalogMenu from "./CatalogMenu";

import RoadConceptJBSupplyTransformer from "@/transformers/catalog/services/roadConceptJBSupply";

const RCONCEPTURL = "services/roadconceptjb";

export default {
  name: "RoadConcepts",

  components: {
    ConceptsList,
    CatalogMenu,
  },

  mounted() {
    return Promise.all([
      catalogService.fetch("services/families", { useStore: true }),
      catalogService.fetch("services/subfamilies", { useStore: true }),
      catalogService.fetch("services/details", { useStore: true }),
    ]).then(([families, subfamilies, details]) => (this.details = details));
  },

  methods: {
    filterData(searchTerm) {
      if (this.currentCatalog) {
        this.loading = true;
        const { currentCatalog } = this;
        const { slug } = this.currentCatalog;
        return catalogService
          .fetch(RCONCEPTURL, {
            noStore: true,
            collection: true,
            id: slug,
            config: { params: { search: searchTerm } },
          })
          .then(
            (roadConcepts) =>
              (this.roadConcepts = roadConcepts.map((concept) => ({
                ...concept,
                showSupplies: false,
              })))
          )
          .catch(this.$fireErrorResponse)
          .finally(() => (this.loading = false));
      }
    },
    loadConceptSupplies(concept, index) {
      if (!this.roadConcepts[index].showSupplies) {
        this.loadingSupplies = true;
        catalogService
          .fetch(RCONCEPTURL, {
            noStore: true,
            collection: true,
            id: `${concept.id}/supplies`,
            transformer: RoadConceptJBSupplyTransformer,
          })
          .then((supplies) => {
            this.roadConcepts[index].showSupplies = true;
            this.roadConcepts[index].supplies = supplies.map((supply) => {
              return {
                ...supply.supply,
                ...supply,
              };
            });
          })
          .catch(this.$fireErrorResponse)
          .finally(() => (this.loadingSupplies = false));
        this.currentConcept = concept;
        return;
      }
      this.roadConcepts[index].showSupplies = false;
    },
    conceptSaved({ original, updated }) {
      const url = `${RCONCEPTURL}`;
      catalogService
        .create(url, updated)
        .then((concept) => {
          this.roadConcepts.push(concept);
          this.$successMessage({ title: `Nuevo concepto: ${concept.name}` });
        })
        .catch(this.$fireErrorResponse);
    },
    conceptUpdated({ updated, original }) {
      catalogService
        .update(RCONCEPTURL, updated)
        .then((concept) => {
          const concepts = this.roadConcepts;
          const pos = concepts.indexOf(original);
          concepts.splice(pos, 1, concept);
          this.$successMessage({
            title: `Concepto "${concept.name}" actualizado`,
          });
        })
        .catch(this.$fireErrorResponse);
    },
    deleteConcept(concept, index) {
      catalogService
        .delete(RCONCEPTURL, concept)
        .then(() => {
          this.roadConcepts.splice(index, 1);
        })
        .catch(this.$fireErrorResponse);
    },
    loadCatalogData(catalog) {
      this.currentCatalog = catalog;
      this.currentDetail = null;
      this.roadConcepts = [];
    },
  },
  data() {
    return {
      details: [],
      roadConcepts: [],
      supplies: [],
      currentConcept: null,
      currentDetail: null,
      loading: false,
      currentConceptSupplies: [],
      currentCatalog: null,
      currentCatalogId: null,

      loadingSupplies: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/Catalogs/RoadConceptsAdvance/index.vue